






























































































































import SeletorDeOrigem from '@/components/fiscal/SeletorDeOrigem.vue';
import SeletorDeRegimeFiscal from '@/components/fiscal/SeletorDeRegimeFiscal.vue';
import SeletorDeRegraFiscal from '@/components/fiscal/SeletorDeRegraFiscal.vue';
import { CapaRegraImposto, FormRegraFiscalDeProduto, TipoDeTransacaoDeRegraFiscal, TipoEntradaSaidaRegraFiscal } from '@/models';
import { RegraFiscal } from '@/models/fiscal/RegrasFiscais';
import AlertModule from '@/store/vuex/aplicacao/AlertModule';
import { RegrasFiscaisUseCase } from '@/usecases/fiscal/RegrasFiscaisUseCase';
import { Component, Vue } from 'vue-property-decorator';

@Component({
	components: {
		SeletorDeRegimeFiscal,
		SeletorDeOrigem,
		SeletorDeRegraFiscal,
	},
})
export default class DialogoDeAdicionarNovasRegrasFiscais extends Vue {
	regrasFiscaisUseCase = new RegrasFiscaisUseCase();
	mostra = false;
	carregandoSalvamento = false
	
	entradaSaida = ''
	transacao = ''
	regime = ''
	codigoOrigem: number | null = null
	tipoOrigem = null
	regra: CapaRegraImposto = {
		origem: {
			codigo: '',
			descricao: '',
		},
	} as CapaRegraImposto

	tributacao: FormRegraFiscalDeProduto = {
		regra: null,
	} as FormRegraFiscalDeProduto

	tiposTransacao: TipoDeTransacaoDeRegraFiscal[] = [
		'Venda', 'Devolução', 'Transferência', 'Consignado',
		'Demonstração', 'Brinde', 'Outros', 'Conserto',
		'Ativo', 'Consumo', 'Uniforme', 'Não Configuradas',
	];

	entradasESaidas: TipoEntradaSaidaRegraFiscal[] = [
		'Entrada', 'Saída', 'Não Configuradas',
	];

	mostrar() {
		this.mostra = true;
	}

	computeLevel(
		codigoOrigem: number | null | undefined,
		tipoOrigem: string | null | undefined,
	): number {
		const hasOrigem = codigoOrigem !== null && codigoOrigem !== undefined;
		const hasTipo =
			tipoOrigem !== null &&
			tipoOrigem !== undefined &&
			tipoOrigem !== 'NAO_CONFIGURADAS';

		if (hasOrigem && hasTipo) return 1;
		if (!hasTipo && hasOrigem) return 2;
		if (hasTipo && !hasOrigem) return 3;
		return 4;
	}

	async concluir() {
		if(!this.regime) return AlertModule.setError('Regime Fiscal é obrigatorio');
		if(!this.tributacao.regra || !this.tributacao.regra.descricao) return AlertModule.setError('Tributação é obrigatorio');
		if(!this.transacao) return AlertModule.setError('Transação é obrigatorio');
		if(!this.entradaSaida) return AlertModule.setError('Entrada/Saida é obrigatorio');

		try{
			this.carregandoSalvamento = true

			const regrasFiscais = {
				regimeFiscal: this.regime,
				tributacao: this.tributacao.regra.descricao,
				transacao: this.transacao,
				entradaSaida: this.entradaSaida,
				tipoOrigem:  this.tipoOrigem ? this.tipoOrigem : null,
				codigoOrigem: this.regra.origem?.codigo && this.regra.origem.codigo !== ''
					? Number(this.regra.origem.codigo)
					: null,
				level: this.computeLevel(Number(this.regra.origem.codigo), this.tipoOrigem) as 1 | 2 | 3 | 4,
			} as RegraFiscal

			await this.regrasFiscaisUseCase.saveRegrasFiscais(regrasFiscais);

			this.carregandoSalvamento = false;
			this.limpar();
			this.$emit('salvou')
			this.mostra = false;
		} catch (e) {
			this.carregandoSalvamento = false;
			AlertModule.setError('Erro ao salvar regra fiscal: ' + (e as any)?.response?.data?.message);
		}
	}

	cancelar(){
		this.limpar()
		this.mostra = false
	}

	limpar(){
		this.entradaSaida = ''
		this.transacao = ''
		this.regime = ''
		this.codigoOrigem = null
		this.tributacao.regra = null
		this.regra = {
			origem: {
				codigo: '',
				descricao: '',
			},
		} as CapaRegraImposto
		this.tipoOrigem = null
	}
}
